import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIcon } from '../mat-icon/mat-icon';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'empty-state',
    imports: [MatIcon, ButtonModule],
    templateUrl: './empty-state.component.html',
    styleUrl: './empty-state.component.scss',
})
export class EmptyStateComponent {
  @Input() icon: string = 'info';
  @Input() title: string = 'No data available';
  @Input() subtitle: string = '';
  @Input() buttonText: string = 'Add data';
  @Input() showButton: boolean = false;

  @Output() buttonClick = new EventEmitter();

  buttonAction() {
    this.buttonClick.emit();
  }
}
